export default __webpack_public_path__ + "static/media/decorativa2.18a55948.jpg";